export const getModules = (type)=> { 
  // 1文章,2 视频, 3 电视直播, 4 直播详情, 5 栏目详情, 6 图片详情, 7 爆料详情, 8 音频详情, 9 活动直播详情,10新闻专题,11人物专题
  var modules=''
  switch (type) {
    case 1:
      modules='newsDetail'
      break;
    case 2:
      modules='videoDetail'
      break;
    case 3:
      modules='tvLiveDetail'
      break;
    case 4:
      modules='liveDetail'
      break;
    case 5:
      modules='columnDetail'
      break;
    case 6:
      modules='imageDetail'
      break;
    case 7:
      modules='home'
      break;
    case 8:
      modules='audioDetail'
      break;
    case 9:
      modules='activityLiveDetail'
      break;
    case 10:
      modules='newsSpecia'
      break;
    case 11:
      modules='personSpecia'
      break;
  }
  return modules
}